import { createContext } from 'react';
import { IUseMultisportApi } from '../../../../packages/types';

const MultisportApiContext = createContext<IUseMultisportApi>({});

export default MultisportApiContext;
